// One accessible control instead of overlapping legacy Weglot switchers.
// Available languages and translations continue to come from the existing project.
(() => {
  let root = document.querySelector('[data-yl-language]');
  const provider = window.Weglot;
  if (!root || !provider || root.dataset.ready) return;
  // Switching uses public project codes; HTML pronunciation uses BCP 47 tags.
  const languageTags = { a0: 'pt-BR' };
  const languageNames = new Intl.DisplayNames(['en'], { type: 'language', fallback: 'none' });
  const htmlLanguage = code => {
    try {
      const configured = provider.options.languages.find(language =>
        language.language_to === code || language.custom_code === code);
      const original = configured?.language_to || code;
      const locale = new Intl.Locale(languageTags[original] || original);
      return languageNames.of(locale.language) ? locale.toString() : null;
    } catch { return null; }
  };
  let select, button, status;
  const sync = () => {
    const current = provider.getCurrentLang();
    select.value = current;
    // A failed request can leave the provider's current code ahead of the DOM.
    const tag = htmlLanguage(document.documentElement.lang);
    if (tag) document.documentElement.lang = tag;
    button.disabled = false;
    root.removeAttribute('aria-busy');
  };
  const initialize = () => {
    root = document.querySelector('[data-yl-language]');
    if (!root) return;
    select = root.querySelector('select');
    button = root.querySelector('button');
    status = root.querySelector('[role="status"]');
    if (!root.dataset.ready) {
      root.dataset.ready = 'true';
      button.addEventListener('click', changeLanguage);
    }
    // Match Weglot's public/private language availability in our custom control.
    const languages = provider.options.languages.filter(language =>
      language.enabled !== false || provider.options.private_mode);
    const codes = [...new Set([provider.options.language_from,
      ...languages.map(language => language.custom_code || language.language_to)].filter(Boolean))];
    select.replaceChildren(...codes.map(code => {
      const option = document.createElement('option');
      option.value = code;
      option.textContent = provider.getLanguageName(code);
      const tag = htmlLanguage(code);
      if (tag) option.lang = tag;
      return option;
    }));
    sync();
    root.hidden = codes.length < 2;
  };
  const changeLanguage = () => {
    if (select.value === provider.getCurrentLang()) return;
    status.textContent = 'Updating language…';
    button.disabled = true;
    root.setAttribute('aria-busy', 'true');
    try {
      provider.switchTo(select.value);
    } catch {
      sync();
      status.textContent = 'Language could not be changed. Please try again.';
    }
    // A provider/network failure must not leave the control permanently disabled.
    const pendingRoot = root;
    window.setTimeout(() => {
      if (root !== pendingRoot || !button.disabled) return;
      sync();
      status.textContent = 'Check your connection and try again if the language did not change.';
    }, 15000);
  };
  provider.on('initialized', initialize);
  provider.on('languageChanged', () => {
    if (!root) return;
    sync();
    status.textContent = `Language: ${provider.getLanguageName(provider.getCurrentLang())}`;
  });
  document.addEventListener('shopify:section:load', () => { if (provider.initialized) initialize(); });
  if (provider.initialized) initialize();
})();
